import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import * as sampleModule from 'written-number';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
('jspdf-autotable');

@Component({
  selector: 'pg-voucher-sale',
  templateUrl: './ticket-sale.component.html',
  styleUrls: ['./ticket-sale.component.scss']
})
export class VoucherSaleComponent implements OnInit, AfterViewInit {
  @Input() dataForVoucher: any;
  dataForVoucherFlattened: any[] = [];
  newUserUsername = '';
  newAmount = '';
  writtenNumber = sampleModule;
  qrCodeImage: string;
  methodPaymentName: string;
  date: string;
  time: string;

  ngOnInit() {
    this.flatDetailsForVoucher(this.dataForVoucher.details);
    this.asterisk(this.dataForVoucher.document.userUsername);
    this.letter(this.dataForVoucher.document.amount);
    this.qrCodeImage = this.dataForVoucher.qrCodeImage;
    this.methodPaymentName = this.dataForVoucher.methodPaymentName;
    const utcDate = this.dataForVoucher.document.createdAt;
    this.date = String(utcDate).substr(0, 10).split('-').reverse().join('/');
    this.time = String(utcDate).substr(11, 8);
  }

  ngAfterViewInit() {
    this.generatePDF();
  }

  flatDetailsForVoucher(saleDetails: any[]) {
    for (const saleDetail of saleDetails) {
      Object.entries(saleDetail.formats).map(([formatName, formatDetails]) => {
        const newFlattenedDetail = {
          code: saleDetail.codeProduct,
          description: saleDetail.description,
          format: formatName,
          quantity: formatDetails['cantidad'],
          priceUnit: formatDetails['precio'],
          price: formatDetails['cantidad'] * formatDetails['precio']
        };
        this.dataForVoucherFlattened.push(newFlattenedDetail);
      });
    }
  }

  generatePDF() {
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [80, 270]
    });
    const fontSizeNormal = 8;
    const fontSizeBig = 10;
    const startY = 10;
    doc.setFont('helvetica', 'normal');

    const businessName = this.dataForVoucher.document.businessName || '';
    const businessRuc = this.dataForVoucher.document.businessRuc || '';
    const businessAddressFiscal = this.dataForVoucher.document.businessAddressFiscal || '';

    this.textCenter(doc, businessName, fontSizeBig, startY);
    this.textCenter(doc, `RUC: ${businessRuc}`, fontSizeBig, startY + 5);
    this.textCenter(doc, businessAddressFiscal, fontSizeNormal, startY + 10);

    const typeVoucher = this.dataForVoucher.document.typeVoucher || '';
    const numberDocument = this.dataForVoucher.document.numberDocument || '';

    this.setLine(doc, 3, 22);
    this.textCenter(doc, typeVoucher, fontSizeNormal,startY + 15);
    this.textCenter(doc, numberDocument, fontSizeBig,startY + 18, true);
    this.setLine(doc, 3, 30);

    const utcDate = String(this.dataForVoucher.document.createdAt);
    const date = utcDate.substr(0, 10).split('-').reverse().join('/');
    const time = utcDate.substr(11, 8);
    const [hours, minutes, seconds] = time.split(':').map(Number);
    const newHours = hours + 5;
    const adjustedHours = newHours % 24;
    const newTime = `${adjustedHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    const clientName = this.dataForVoucher.document.clientName || '';
    const clientAddress = this.dataForVoucher.document.clientAddress || '';
    const clientIdentifier = this.dataForVoucher.document.clientIdentifier || '';
    const clientIdNumber = this.dataForVoucher.document.clientIdNumber || '';

    this.textLeft(doc, "FECHA:", date, fontSizeNormal, startY + 25);
    this.textLeft(doc, "HORA:", newTime, fontSizeNormal, startY + 28);
    this.textLeft(doc, "NOMBRES:", clientName, fontSizeNormal, startY + 31);
    this.textLeft(doc, "DIRECCIÓN:", clientAddress, fontSizeNormal, startY + 34);
    this.textLeft(doc, "DOCUMENTO:", clientIdentifier, fontSizeNormal, startY + 37);
    this.textLeft(doc, "Nº DOCUMENTO:", clientIdNumber, fontSizeNormal, startY + 40);

    const columns = ['Producto', 'Cant.', 'Pre.', 'Tot.'];
    const data = [];
    this.dataForVoucherFlattened.forEach((element) => {
      data.push([
        `${element.description.toLocaleUpperCase()} - ${element.format.toLocaleUpperCase()}`,
        element.quantity,
        element.priceUnit,
        element.price
      ]);
    });
    this.setLine(doc, 3, 55, true);
    autoTable(doc, {
      head: [columns],
      body: data,
      startY: startY + 47,
      styles: {
        fontSize: fontSizeNormal,
        lineColor: 200,
        lineWidth: 0,
        valign: 'middle'
      },
      tableWidth: 'auto',
      margin: { top: 0, right: 3, bottom: 0, left: 3 },
      theme: 'plain',
      headStyles: {
        fillColor: false,
        textColor: [0, 0, 0],
        halign: 'center'
      },
      columnStyles: {
        0: { cellWidth: 30, halign: 'left' },
        1: { cellWidth: 14, halign: 'center' },
        2: { cellWidth: 15, halign: 'center' },
        3: { cellWidth: 15, halign: 'center' }
      }
    });
    let finalY = (doc as any).lastAutoTable.finalY;

    const amount = Number(this.dataForVoucher.document.amount);
    const payWith = Number(this.dataForVoucher.document.payWith);
    const subtotal = amount *0.82;
    const igv = amount * 0.18;
    const back = payWith - amount;

    this.setLine(doc, 40, finalY, true);
    this.textRight(doc, 'Subtotal', `S/. ${subtotal.toFixed(2)}`, fontSizeNormal, finalY + 3);
    this.textRight(doc, 'Descuento', 'S/. 0.00', fontSizeNormal, finalY + 6);
    this.textRight(doc, 'IGV', `S/. ${igv.toFixed(2)}`, fontSizeNormal, finalY + 9);
    this.setLine(doc, 40, finalY + 10, true);
    this.textRight(doc, 'Total', `S/. ${amount.toFixed(2)}`, fontSizeNormal, finalY + 13);

    this.textLeft(doc, "SON:", this.newAmount.toUpperCase(), fontSizeNormal, finalY + 19);
    this.textLeft(doc, "FORMA DE PAGO:", this.methodPaymentName.toLocaleUpperCase(), fontSizeNormal, finalY + 22);
    this.textLeft(doc, "PAGO CON:", `S/. ${payWith.toFixed(2)}`, fontSizeNormal, finalY + 25);
    this.textLeft(doc, "VUELTO:", `S/. ${back.toFixed(2)}`, fontSizeNormal, finalY + 28);
    this.textLeft(doc, "CAJERO:", this.newUserUsername.toUpperCase(), fontSizeNormal, finalY + 31);

    const qrSize = 40; 
    const qrX = 20; 
    const qrY = finalY + 32; 
    doc.addImage(this.qrCodeImage, 'PNG', qrX, qrY, qrSize, qrSize);
    doc.save(`${this.dataForVoucher.document.numberDocument}.pdf`);
  }

  ngOnDestroy() {
    this.dataForVoucher = undefined;
    this.dataForVoucherFlattened = [];
  }

  asterisk(name) {
    const letters = '' + name.slice(2, -2);

    const asteriskLetters = letters.replace(/[a-z0-9\-_.,]/gi, function () {
      return '*';
    });
    this.newUserUsername =
      name.substr(0, 2) + asteriskLetters + name.substr(-2, 2);
  }

  letter(value) {
    this.writtenNumber.defaults.lang = 'es';
    const integerNumberText = this.writtenNumber(Math.trunc(value));
    const integerNumber = Math.trunc(value);
    const decimalNumber = (value - integerNumber) * 100;
    this.newAmount =
      integerNumberText + ' CON ' + decimalNumber.toFixed(2) + '/100 SOLES';
  }

  private textCenter(
    doc: jsPDF,
    text: string,
    size: number,
    y: number,
    bold: boolean = false
  ) {
    doc.setFontSize(size);
    const pageWidth = doc.internal.pageSize.width;
    const textWidth = doc.getTextWidth(text);
    const textOffset = (pageWidth - textWidth) / 2;
    if (bold) {
      doc.setFont('helvetica', 'bold');
      doc.text(text, textOffset, y);
      doc.setFont('helvetica', 'normal');
      return;
    }
    doc.text(text, textOffset, y);
  }

  private textRight(
    doc: jsPDF,
    item: string,
    description: string,
    size: number,
    y: number
  ) {
    doc.setFontSize(size);
    const pageWidth = doc.internal.pageSize.width;
    const textOffset = 5;
    const blockItem = 38;
    doc.setFont('helvetica', 'bold');
    const descriptionWidth = doc.getTextWidth(description) + textOffset + 1;
    doc.text(item, pageWidth - blockItem, y);
    doc.setFont('helvetica', 'normal');
    doc.text(description, pageWidth - descriptionWidth, y);
  }

  private textLeft (
    doc: jsPDF,
    item: string,
    description: string,
    size: number,
    y: number
  ) {
    doc.setFontSize(size);
    const textOffset = 3;
    doc.setFont("helvetica", "bold");
    const itemWidth = doc.getTextWidth(item) + textOffset + 1;
    doc.text(item, textOffset, y);
    doc.setFont("helvetica", "normal");
    doc.text(description, itemWidth, y);
  };

  private setLine(doc: jsPDF, x: number, y: number, color: boolean = false) {
    doc.setLineWidth(0.3);
    if (color) {
      doc.setDrawColor(192, 192, 192);
      doc.line(x, y, 77, y);
      doc.setDrawColor(0);
      return;
    }
    doc.line(x, y, 77, y);
  }
}
